var DOLLAR_SIGN = '$';
var POUND_SIGN = '£';
var EURO_SIGN = '€';
var INDIAN_RUPEE_SIGN = '₹';

/**
 * Get the currency sign for the provided country code.
 * @param countryCode - The country code (e.g. 'USD')
 * @example
 * // returns '£'
 * getCurrencySign('GBP')
 */
export function getCurrencySign(countryCode) {
  switch (countryCode.toLowerCase()) {
    case 'cad':
    case 'usd':
    case 'aud':
      return DOLLAR_SIGN;
    case 'gbp':
      return POUND_SIGN;
    case 'irl':
      return EURO_SIGN;
    case 'ind':
      return INDIAN_RUPEE_SIGN;
    default:
      return DOLLAR_SIGN;
  }
}